/* category
food: 1
fastfood: 2
drinkts: 3
Salad and appetizer: 4

  ,{
    id: 1,
    source_url: "",
    image_url: "/assets/img/1.jpg",
    title: "",
    publisher:"",
    ingredients: [],
    how_to_make: [],
    category: 1
  },
*/

export const recipeData = [
  {
    id: 1,
    title: "کوفته کباب خوشمزه",
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/9592069-%DA%A9%D9%88%D9%81%D8%AA%D9%87-%DA%A9%D8%A8%D8%A7%D8%A8-%D8%AE%D9%88%D8%B4%D9%85%D8%B2%D9%87",
    image_url: "/assets/img/1.jpg",
    publisher: "K.M",
    ingredients: [
      "۵۰۰گرم گوشت",
      "1 پیمانه برنج",
      "1 عدد تخم مرغ",
      "1 عدد پیاز بزرگ",
      "1 عدد سیب زمینی کوچک",
      "2 پیمانه ارد نخود خام",
      "ابغوره به مقدار لازم",
      "شکر و نمک و فلفل"
    ],
    how_to_make: [
      "1 ابتدا پیاز را در گوشت رنده کرده و نمک و فلفل زرد چوبه اضافه میکنیم",
      "2 سپس سیب زمینی نیز رنده کرده و آرد نخود و تخم مرغ اضافه کرده و خوب ورز میدهیم",
      "3 به صورت شامی میگیریم و در روغن سرخ کرده و در قابلمه ای که قبلا آب و زرد چوبه میریزیم ودر حال جوش کوفته ها را میریزم و سپس چاشنی ها را اضافه کرده میگذاریم به مدت ۴۰ دقیقه با شعله کم بپزد",
      "4 انشالله خوشتان امده باشد نوش جان"
    ],
    category: 1
  },
  {
    id: 2,
    title: "کباب تابه ای مرغ",
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11159634-%DA%A9%D8%A8%D8%A7%D8%A8-%D8%AA%D8%A7%D8%A8%D9%87-%D8%A7%DB%8C-%D9%85%D8%B1%D8%BA",
    image_url: "/assets/img/2.jpg",
    publisher: "Mahdi",
    ingredients: [
      "سینه مرغ به مقدار دلخواه(غیراز سینه مرغ هم میشه)",
      "حبه سیر ۲",
      "1 عدد پیاز متوسط",
      "دلمه کمی",
      "زردچوبه به مقدار دلخواه",
      "نمک فلفل آویشن",
      "2 قاشق روغن مایع",
      "تخم مرغ دو عدد"
    ],
    how_to_make: [
      "مرغ و همراه با دلمه و پیاز و سیرچرخ میکنیم وبعد ادویه ها و روغن و تخم مرغ میریزیم داخل ظرف مرغ چرخ شده و خوب هم میزنیم و بعد درون ماهیتابه رژیمی خیلی کم روعن زیتون یا کره یا روعن مایع میریزیم و موادو میریزیم داخلش درشو میزاریم خوب بپزه و سرخ بشه نوش جان"
    ],
    category: 1
  },
  {
    id: 3,
    title: "جوجه کباب تابه ای",
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11155661-%D8%AC%D9%88%D8%AC%D9%87-%DA%A9%D8%A8%D8%A7%D8%A8-%D8%AA%D8%A7%D8%A8%D9%87-%D8%A7%DB%8C",
    image_url: "/assets/img/3.jpg",
    publisher: "Fatimasoleymani1376",
    ingredients: [
      "۲ عدد سینه مرغ",
      "۲۰۰ گرم بال مرغ (میتونید کتف مرغ روهم جایگزین کنید)",
      "نمک و فلفل و زردچوبه و پودر سیر و ادویه جوجه به میزان دلخواه",
      "آبلیمو به میزان لازم",
      "۲ عدد پیاز متوسط",
      "زعفران دم شده",
      "۱ عدد فلفل دلمه کوچک"
    ],
    how_to_make: [
      "از شب قبل پیاز رو خلالی خرد کرد و سینه مرغ و بال ها رو به اون اضافه میکنیم و بعد ادویه و زعفران و فلفل دلمه رو اضافه میکنیم داخل یخچال میگذاریم",
      "نیم ساعت قبل پخت آبلیمو رو اضافه میکنیم و تابه رژیمی رو روغن میزنیم میگذاریم داغ شود بعد مرغ ها رو به سیخ میکشیم و داخل تابه میچنیم. در تابه رو میبندیم تا مرغ ها پخته شوند. بعد از آن در تابه رو باز میگذاریم تا آب مرغ کشیده شود و سطح مرغ سرخ بشه میتونید از یک حبه کره به دلخواه برای خوشمزه شدن به جوجه ها اضافه کنید. نوش جونتون"
    ],
    category: 1
  },
  {
    id: 4,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11153339-%D8%AC%D9%88%D8%AC%D9%87-%DA%A9%D8%A8%D8%A7%D8%A8-%D8%B1%D8%B3%D8%AA%D9%88%D8%B1%D8%A7%D9%86%DB%8C",
    image_url: "/assets/img/4.jpg",
    title: "جوجه کباب رستورانی",
    publisher: "Zahra",
    ingredients: [
      "مرغ",
      "زعفران",
      "فلفل سیاه",
      "آبلیمو",
      "پیاز",
      "روغن زیتون",
      "نمک"
    ],
    how_to_make: [
      "ابتدا مرغارو با پیاز و آبلیمو بذارید سه چهار ساعت بخوابن",
      "بعد تو ظرف دیگه روغن زیتون و زعفران و فلفل و نمک گذاشته دونه دونه مرغ ها رو کاملا عاری از پیاز کرده و میگذاریم در زعفران",
      "بعد دوساعت خوابیدن با زعفران و روغن نوش جان کنید"
    ],
    category: 1
  },
  {
    id: 5,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11154667-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%D8%B1%DA%98%DB%8C%D9%85%DB%8C",
    image_url: "/assets/img/5.jpg",
    title: "قورمه سبزی رژیمی",
    publisher: "Yas",
    ingredients: [
      "۱ بسته سبزی خورشتی",
      "ادویه نمک فلفل سیاه به میزان لازم",
      "۳ عدد لیمو عمانی",
      "۱ عدد کنسرو لوبیا چیتی",
      "۷ تکه گوشت بدون چربی متوسط",
      "روغن زیتون به میزان لازم",
      "۱ عدد پیاز"
    ],
    how_to_make: [
      "گوشت و سبزی و پیاز خرد شده به همره ادویه و کمی روغن زیتون تفت دهید تا گوشت از حالت خامی در بیاد اما زیاد سرخ نشود",
      "به مواد آب اضافه میکنیم لیمو عمانی را سوراخ میکنیم و اضافه میکنیم درب ظرف را میگذاریم",
      "کمی گوشت نرم شد کنسرو لوبیا چیتی را کامل در خورشت میریزیم همچنین نمک اضافه میکنیم چون گوشت را سفت میکنه اول کار نمک اضافه بشه",
      "درب ظرف را میگذاریم تا خورشت کامل جا بیفته و نوش جان میکنید"
    ],
    category: 1
  },
  {
    id: 6,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11149369-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%D8%AE%D9%88%D8%B4%D9%85%D8%B2%D9%87",
    image_url: "/assets/img/6.jpg",
    title: "قورمه سبزی خوشمزه",
    publisher: "N.n A.a",
    ingredients: [
      "۲۵۰ گرم گوشت",
      "۲۵۰ گرم سبزی خورشتی سرخ شده",
      "۲ عدد پیاز متوسط",
      "۲ پیمانه لوبیا چیتی",
      "۵ عدد لیمو عمانی",
      "نمک فلفل سیاه زردچوبه پودر سیر به دلخواه خودتون"
    ],
    how_to_make: [
      "من گوشت و با پیاز سرخ میکنم جدا. سبزی هم سرخ میکنم لوبیا و لیمو و بقیه مواد و با هم میزارم تو دیگ یه ساعت و نیم زمان میدم حسابی جا بیفته"
    ],
    category: 1
  },
  {
    id: 7,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11140886-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%D8%AC%D8%A7%D9%86%D8%A7%D9%86%D9%87-%F0%9F%98%8B",
    image_url: "/assets/img/7.jpg",
    title: "قورمه سبزی جانانه",
    publisher: "سما",
    ingredients: [
      "سبزی خورشتی (تره. گشنیز. جعفری.اسفناج و شنبلیله به مقدار کم)",
      "گوشت گوسفندی با استخوان وقلم به مقدار دلخواه",
      "۱ الی ۲ قاشق رب گوجه فرنگی",
      "۱/۳ تمر هندی",
      "لوبیا چیتی به مقدار لازم",
      "لیمو عمانی یا پود لیمو به مقدار دلخواه"
    ],
    how_to_make: [
      "لوبیا چیتی و از روز قبل خیس میکنیم و چند بار آبش و عوض میکنیم تا نفخش گرفته بشه و میپزیمش با آب به اندازه ای که خیلی پخته نباشه که تو خورشت له بشه"
    ],
    category: 1
  },
  {
    id: 8,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10971039-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%D9%85%D8%B1%D8%BA",
    image_url: "/assets/img/8.jpg",
    title: "قورمه سبزی مرغ",
    publisher: "هدی",
    ingredients: [
      "گوشت مرغ",
      "1 بسته سبزی خورشتی",
      "2 تا 3 قاشق رب گوجه",
      "2 عدد لیموعمانی",
      "1 بسته لوبیا قرمز"
    ],
    how_to_make: [
      "ابتدا سبزی رو میذاریم سرخ شه",
      "بعد گوشت رو میزاریم سرخ شه",
      "بعد لیموعمانی رو دو نصف میکنیم میزاریم تو آب گرم تا تلخیش بره",
      "بعد که گوشت سرخ شد، سبزی رو که جدا سرخ کردیم اضافه میکنیم",
      "بعد بهش رب گوجه با لوبیا لیمو اضافه میکنیم در مرحله آخر هم آب که گذاشتیم جوشید اضافه میکنیم. زیر شعله رو ملایم میکنیم تا خوب جا بیفته. نوش جون"
    ],
    category: 1
  },
  {
    id: 9,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10970433-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%DA%AF%D9%88%D8%B4%D8%AA-%D9%82%D9%84%D9%82%D9%84%DB%8C",
    image_url: "/assets/img/9.jpg",
    title: "قورمه سبزی گوشت قلقلی",
    publisher: "هدی",
    ingredients: [
      "گوشت چرخ کرده به تعدادهر نفری که باشید",
      "سبزی خورشتی",
      "لیموعمانی",
      "لوبیا قرمز من یه بسته انداختم",
      "1 عدد پیاز کوچک",
      "رب گوجه هم به مقدار لازم"
    ],
    how_to_make: [
      "ابتدا پیاز رو رنده میکنیم با گوشت چرخ شده قاطی میکنیم هم میزنیم به صورت قلقلی در میاریم",
      "بعد روغن داخل قابلمه میریزیم سبزی رو یکم سرخ میکنیم بهش رب گوجه اضافه میکنیم تا بوی خامی رب بره بعد لیمو هامون رو که دونصف کردیم رو داخل آب گذاشتیم میندازیم داخل قابلمه",
      "بعد لوبیا قرمز رو میندازیم و در اخرم آب جوش میریزم رو شعله ملایم میزاریم تاکمی آبش گرفته شه بعد درمرحله آخر که گوشت قلقلی ها رو سرخ کردیم تمیززز.. آروم داخل خورشت میندازیم. زیاد خورشتتون رو بهم نزنید که گوشتاتون ازهم باز نشن آب خورشت که گرفته شد شعله خاموش آماده سرو هستش.نوش جون"
    ],
    category: 1
  },
  {
    id: 10,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10959109-%D9%82%D9%88%D8%B1%D9%85%D9%87-%D8%B3%D8%A8%D8%B2%DB%8C-%D8%A8%D8%A7-%D9%85%D8%B1%D8%BA",
    image_url: "/assets/img/10.jpg",
    title: "قورمه سبزی با مرغ",
    publisher: "salimeh",
    ingredients: [
      "2 عدد سینه مرغ",
      "400 گرم سبزی قرمه ای",
      "2 عدد لیمو عمانی پوست کنده",
      "نمک و فلفل و زردچوبه و روغن به مقدار لازم",
      "2 قاشق رب",
      "1 ونیم پیمانه لوبیا چیتی نم پز شده"
    ],
    how_to_make: [
      "من از قبل لوبیا رو. پختم. و. نم پز کردم",
      "مرغ رو تکه تکه کردم به اندازه های دلخواه و با آب و پیاز و حرارت گزاستم تا آب به جوش اومد و بوی بعد مرغ رو بگیره و بعد آبکش میکنم و آبش رو دور میریزنم",
      "سبزی رو با روغن سرخ کردم و بهش لوبیا های نم. پز شده رو اضافه کردم و همچنین مرغ ها رو",
      "و. در آخر لیمو عمانی و زردچوبه و. نمک و فلفل و رب بهش اضافه میکنم و بعد چند دقیقه که رب کامل حل شد قورمه ما آماده است",
      "نوش جان"
    ],
    category: 1
  },
  {
    id: 11,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10957942-%D9%82%D9%88%D8%B1%D9%85%D9%87-%DA%A9%D8%A7%D9%84%D8%A8%D8%A7%D8%B3",
    image_url: "/assets/img/11.jpg",
    title: "قورمه کالباس",
    publisher: "رومیصا",
    ingredients: ["کالباس", "۳ عدد گوجه متوسط", "نمک وفلفل"],
    how_to_make: [
      "اول همه کالباس ها رو سرخ میکنیم",
      "وگوجه ها را رنده میکنیم و در دوغن تفت میدیم و نمک و فلفل رو میریزیم توش و میزاریم آبش تموم بشه بعد کالباسای سرخ شده رو اضافه میکنیم",
      "نوش جان"
    ],
    category: 1
  },
  {
    id: 12,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11179938-%D9%82%DB%8C%D9%85%D9%87-%D8%A8%D8%A7%D8%AF%D9%85%D8%AC%D9%88%D9%86-%D9%85%D8%AC%D9%84%D8%B3%DB%8C",
    image_url: "/assets/img/12.jpg",
    title: "قیمه بادمجون مجلسی",
    publisher: "میترا",
    ingredients: [
      "۴۰۰ گرم گوشت خورشتی",
      "۸ عدد بادمجون قلمی",
      "۲۰۰ گرم لپه",
      "۲ عدد پیاز",
      "۳ عدد گوجه فرنگی",
      "۴ عدد لیمو عمانی",
      "۳ ق غ خ رب گوجه",
      "زعفرون",
      "نمک،فلفل،زردچوبه",
      "۳ عدد سیب زمینی"
    ],
    how_to_make: [
      "با سلام🌸لپه رو برای پخت بهتر وگرفتن نفخ اون از دو ساعت قبل بخیسونید.",
      "ابتدا پیازارو نگینی کردم کمی که سرخ شد گوشت رو اضافه کردم وتفت دادم ‌‌کمی که سرخ شد زردچوبه وفلفل اضافه کردم ،بعد لپه هارو بهش اضافه کردم وبعد چند دقیقه تفت دادن به اون آب جوش اضافه کردم وگذاشتم با حرارت ملایم بپزه.",
      "در حین پخت گوشت ،توی تابه چند قاشق روغن بریزید داغ که شد رب گوجه رو با اون تفت دادم بعد گوجه ها رو اضافه کردم و چند دیقه تفت دادم بعد وسطای پخت گوشت اون بهمراه لیمو عمانی بهش اضافه کردم.اگه رب تفت بخوره باعث خوش رنگ شدن خورشت میشه.",
      "برای آماده کردن بادمجون ها پوست اونارو بگیرید بعد روشون نمک بپاشید ویه ساعتی بذارید تا تلخی اون بره می تونید از وسط برش بزنید یا اینکه اگه ریز وقلمی است همون درسته سرخ کنید.بعد سرخ کردن بادمجون ها اجازه بدید خورشت کامل بپزه و یه رب آخر بادمجون وهمراه نمک وزعفرون به غذا اضافه کنید.وبذارید با غذا که جا بیفته اگه دوس داشتید خورشت ترش بهش می تونید در آخر آبغوره اضافه کنید اونم چند قاشق نه بیشتر.در آخر برای تزیین غذا می تونید از سیب زمینی سرخ شده استفاده کنید.",
      "امیدوارم دوس داشته باشید "
    ],
    category: 1
  },
  {
    id: 13,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11186519-%D9%BE%D9%8A%DA%86%D8%A7%D9%82-%D9%82%D9%8A%D9%85%D9%87-%D8%A7%D8%B1%D8%AF%D8%A8%D9%8A%D9%84",
    image_url: "/assets/img/13.jpg",
    title: "پيچاق قيمه اردبيل",
    publisher: "roghi behmanesh",
    ingredients: [
      "500 گرم گوشت گوسفندي",
      "200 گرم خلال بادام",
      "پياز متوسط 4 عدد",
      "3 ق غ گلاب",
      "2 ق غ رب گوجه فرنگي",
      "زعفران دم كرده ب مقدار لازم",
      "نمك،فلفل ب مقدار لازم",
      "زرده تخم مرغ ب تعداد لازم"
    ],
    how_to_make: [
      "ابتدا گوشت رو ب صورت تكه هاي كوچكتر خرد كرده و با يك پياز كوچك و كمي زرچوبه داخل يك قابلمه با دو ليوان اب ميزاريم تا كمي بپزه.طي اين مدت پياز هارو خلالي كرده و سرخ ميكنيم بعد گوشتمون رو ابكش ميكنيم و مي شوريم تا كفش بره،ب پياز ها اضافه ميكنيم و ي تفت كوچولو ميديم و كمي فلفل و زردچوبه و رب اضافه ميكنيم تا با هم خوب تفتي بخورن بعدش آب گوشتي ك هست اونو اضافه ميكنيم و ميزاريم بپزه",
      "خلال رو با گلاب و زعفرون خيس ميكنيم وقتي گوشتمون يكم پخت خلال رو هم بهش اضافه ميكنيم (هرچقدر پياز اين غذا زياد باشه خوشمزه تر ميشه)",
      "ميزاريم غذامون خوب لعاب بندازه و در اخر زرده تخم مرغ هارو روش ميزنيم و در قابلمه رو ميزاريم تا اوناهم بپزه",
      "غذا حالا اماده سرو هست با كته يا چلو نوش جان بفرماييد 😋",
      "توضيح:چاشني اصلي غذا زعفرون هست اگ دوست داشتين ميتونين رب هم اضافه نكنين و بدون اون درست كنين"
    ],
    category: 1
  },
  {
    id: 14,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11171563-%D8%AE%D9%88%D8%B1%D8%B4-%D9%82%DB%8C%D9%85%D9%87-%D8%A8%D8%A7%D8%AF%D9%85%D8%AC%D8%A7%D9%86",
    image_url: "/assets/img/14.jpg",
    title: "خورشت قیمه بادمجان",
    publisher: "اکرم",
    ingredients: [
      "گوشت گوسفندی ۳۰۰گرم",
      "پیاز یک عدد",
      "1 مشت لپه برای هر نفر",
      "فلفل زردچوبه نمک چوب دارچین",
      "رب ۳قاشق غذاخوری",
      "روغن"
    ],
    how_to_make: [
      "پیاز رو رنده درشت کرده و با روغن تفت میدهیم سپس گوشت رو اضافه کرده و مقداری تفت میدهیم تا رنگ گوشت تغییر کند سپس لپه را به مواد اضافه کرده و کمی تفت میدهیم",
      "ادویه رو به مواد قبلی افزوده و رب هم زده و پس از اینکه مقداری سرخ کردیم",
      "سه چهار لیوان آب داخل قابلمه ریخته و با حرارت کم می گذاریم تا پخته و جا بیفتد",
      "در اواخر پخت نمک و آبلیمو رو به خورشت میزنیم",
      "نوش جااان"
    ],
    category: 1
  },
  {
    id: 15,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11149346-%D8%AE%D9%88%D8%B1%D8%B4-%D9%82%DB%8C%D9%85%D9%87-%D8%A8%D8%A7-%D8%A8%D8%B1%D9%86%D8%AC-%D9%82%D8%A7%D9%84%D8%A8%DB%8C-%D9%88-%D8%B3%D8%A7%D9%84%D8%A7%D8%AF-%D8%B4%DB%8C%D8%B1%D8%A7%D8%B2%DB%8C",
    image_url: "/assets/img/15.jpg",
    title: "خورش قیمه با برنج قالبی و سالاد شیرازی",
    publisher: "Leila",
    ingredients: [
      "۵ قاشق غذاخوری لپه",
      "گوشت خورشتی به مقدار لازم",
      "۱ عدد پیاز بزرگ عدد",
      "۲عدد سیب زمینی خلالی سرخ شده",
      "۲قاشق غ خ سر پر رب گوجه",
      "۲ق غ زعفران دمکرده",
      "لیموعمانی ۳عدد",
      "نمک"
    ],
    how_to_make: [
      "لپه رو جداگانه با آب بذارید بپزه وقتی پخت آبشو بریزید",
      "پیازو نگینی خورد کنید و با روغن سرخ کنید وقتی یکم طلایی شد گوشت و اضافه کنید و تفت بدید وقتی گوشت تغییر رنگ داد و قهوه ای شد رب و اضافه کنید و نمک بزنید و یک کاسه و نیم آب بریزین وقتی شروع به قل زدن کرد لیموهارو اضافه کنید و زیرشو کم کنید تا با شعله ملایم بپزه",
      "وقتی گوشت پخت لپه ی پخته هم بهش اضافه کنید و بذارید تا جا بیوفته",
      "اواخر پخت زعفرانو هم اضافه کنید"
    ],
    category: 1
  },
  {
    id: 16,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10837417-%D9%82%DB%8C%D9%85%D9%87-%DA%A9%D8%AF%D9%88-%D8%A8%D8%A7-%D9%85%D8%B1%D8%BA",
    image_url: "/assets/img/16.jpg",
    title: "قیمه کدو با مرغ",
    publisher: "mah banoo",
    ingredients: [
      "4 تکه ران یا سینه",
      "1 کیلو کدوسبز",
      "3/4 پیمانه لپه",
      "1 عدد پیاز",
      "1/5 ق غ رب گوجه",
      "نمک,فلفل سیاه,زردچوبه"
    ],
    how_to_make: [
      "پیازها را ریز خرد کرده و کمی که تفت خورد تکه های مرغ را با پیاز و زردچوبه سرخ میکنیم.لپه را از قبل پخت دو ساعت خیس میکنیم.",
      "زمانی که مرغ ها کمی سرخ شدند آب و لپه را اضافه میکنیم و اجازه میدهیم تا لپه و مرغ بپزند.اگر جنس لپه ها سفت بودند میتونید از قبل بپزید بعد به مرغ اضافه کنید.",
      "کدوها را پوست گرفته و ورقه ای برش بزنید و سرخ کنید.",
      "نیم ساعت آخر پخت رب را در روغن تفت دهید تا رنگش باز شود بعد به همراه نمک و ادویه ها به خورشت اضافه کنید.یک ربع آخر هم کدوها را روی مرغ ها بچینید تا کمی نرم تر شوند."
    ],
    category: 1
  },
  {
    id: 17,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11165661-%D9%82%DB%8C%D9%85%D9%87-%D8%A8%D8%A7%D8%AF%D9%85%D8%AC%D8%A7%D9%86-%D8%A8%D8%A7-%D9%85%D8%B1%D8%BA-%D9%88-%D8%B2%D8%B1%D8%B4%DA%A9",
    image_url: "/assets/img/17.jpg",
    title: "قیمه بادمجان با مرغ و زرشک",
    publisher: "katayun hasani",
    ingredients: [
      "۳۰۰ گرم سینه مرغ",
      "۲/۳ پیمانه لپه",
      "۱ عدد پیاز کوچک",
      "۳ عدد بادمجان کوچک",
      "۱/۳ پیمانه زرشک",
      "نمک و فلفل سیاه و زردچوبه به مقدار لازم",
      "۱/۴ ق چ خ دارچین",
      "۱ تا ۲عدد لیمو عمانی",
      "۱ ق غ خ رب گوجه فرنگی"
    ],
    how_to_make: [
      "پیاز رو خرد کرده با روغن کمی تفت دادم تا سبک بشه بعد مرغ را تکه کردم اضافه کردم و تفت دادم تا رنگ مرغ عوض بشه بعد لپه و فلفل سیاه و زردچوبه و نمک رو اضافه کردم و مقداری هم آب جوش اضافه کردم و گداشتم ۲ ساعت خورشت پخت بعد زرشک رو تفت دادم و به همراه رب و لیمو عمانی و دارچین و بامجانهای سرخ شده به خورشت اضافه کردم بعد نیم ساعت که خورشت جا افتاد زیرشو خاموش کردم. بیشتر از نیم ساعت با بادمجان نپزید چون بادمجان له میشه و ظاهرش خوب نمیشه. حتی میتونید بادمجان ها را به صورت لایه های نازک ببرید",
      "بعد سرخ کنید و به هنگام سرو روی خورشت بچینید.نوش جان."
    ],
    category: 1
  },
  {
    id: 18,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11145707-%D8%AE%D9%88%D8%B1%D8%B4%D8%AA-%D9%82%DB%8C%D9%85%D9%87-%D8%A8%D8%A7-%D8%B9%D8%B7%D8%B1-%D9%86%D8%B0%D8%B1%DB%8C-%D8%B9%D8%A7%D9%84%DB%8C",
    image_url: "/assets/img/18.jpg",
    title: "خورشت قیمه با عطر نذری عالی",
    publisher: "fatemeh",
    ingredients: [
      "300 گرم گوشت گوسفندی",
      "2 عدد پیاز",
      "2 قاشق غذاخوری رب",
      "چوب دارچین",
      "ادویه",
      "نوک ق غ گلاب",
      "لیمو عمانی",
      "زعفران دم کرده غلیظ",
      "روغن حیوانی",
      "1/2 استکان لپه"
    ],
    how_to_make: [
      "برنج رو به حالت کته با روغن حیوانی درست میکنیم",
      "ابتدا پیاز داغ کرده بعد از سبک شدن پیازها زردچوبه زده و گوشت ها رو داخلش تفت میدیم سپس آب جوش اضافه کرده چوب دارچین می گذاریم و میزاریم بپزه نیم ساعت مانده لپه ها رو اضافه میکنیم و میزاریم کامل بپزه",
      "سپس لیمو ها رو که از ی ساعت قبل داخل آب قرار داده تا تلخیش بره رو با زعفران اضافه کرده میزاریم ده دقیقه بجوشه ی رب آخر گلاب اضافه میکنیم",
      "نوش جان"
    ],
    category: 1
  },
  {
    id: 19,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11008184-%D9%82%DB%8C%D9%85%D9%87-%D9%86%D8%AB%D8%A7%D8%B1-%D8%A7%D9%84%D9%87%D8%A7%D9%85-%D9%BE%D8%B2",
    image_url: "/assets/img/19.jpg",
    title: "قیمه نثار الهام پز",
    publisher: "e.l.h.a.m.v.a.f.a.d.a.r",
    ingredients: [
      "1 عدد سینه مرغ خرد شده",
      "1 عدد پیاز خرد شده",
      "1 قاشق غذاخوری رب گوجه فرنگی",
      "5 پیمانه برنج",
      "1 عدد هویج رنده شده",
      "5 ق غ خ زرشک",
      "خلال پسته به میزان لازم",
      "خلال بادام به میزان لازم",
      "نمک و فلفل به میزان لازم",
      "5 ق غ خ زعفران دم کرده"
    ],
    how_to_make: [
      " ابتدا پیاز رو تفت دادم بعد رب گوجه فرنگی رو اضافه کردم و ادویه جات رو هم بهش اضافه کردم و تفت دادم بعد کنار گذاشتم سینه مرغ رو که از قبل پخته بودم داخل سس گوجه فرنگی گذاشتم روی شعله گذاشتم تا خوب مزه دار بشه بعد رفتم سراغ خلال بادام و پسته وزرشک با یک قاشق کره هر کدوم رو جدا جدا تفت دادم بعد هویج رنده شده رو هم تفت دادم بعد برنج رو که از قبل پخته بودم داخل ظرف مورد نظر ریختم و با گوشت مرغ سسی ومخلفات دیزاین کردم جاتون سبز مهربونا انشالله درست کنید و لذت ببرید خوشمزس",
      "نکته مقدار زعفران دم کرده برای رنگی کردن برنج هستش البته من مقداری داخل سس مرغ ریختم"
    ],
    category: 1
  },
  {
    id: 20,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11178099-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D9%84%D9%BE%D9%87",
    image_url: "/assets/img/20.jpg",
    title: "آبگوشت لپه",
    publisher: "sohi",
    ingredients: [
      "گوشت قرمز : 2۵0گرم",
      "سیب زمینی : 2 عدد",
      "گرم لپه : ۴0",
      "پیاز : 1 عدد",
      "قاشق سوپ خوری رب گوجه فرنگی : ۱",
      "قاشق غذاخوری روغن: ۳",
      "نمک، فلفل سیاه، زردچوبه به مقدار لازم"
    ],
    how_to_make: [
      "ابتدا روغن یا مقداری از دنبه گوشت را در ظرفی آب کنید، سپس پیاز را به صورت خرد یا رنده شده در آن سرخ نمایید.",
      "گوشت را در اندازه های دلخواه خرد کرده و درون روغن و پیاز داغ کاملا تفت دهید تا تغییر رنگ دهد",
      "لپه را جداگانه تفت داده، چند دقیقه قبل از پخته شدن کامل آن را به گوشت و پیاز اضافه کنید.",
      "ادویه به مقدار دلخواه اضافه نمایید تا مزه خامی از بین برود.",
      "مقدار لازم آب به مواد اضافه کنید و اجازه دهید تا غذا خوب بپزد. (پیشنهاد می شود از آبجوش استفاده نشود زیرا باعث می شود مواد کاملا پخته نشده و طعم اصلی غذا از بین برود.)",
      "پس از پخته شدن گوشت سیب زمینی ها را شسته سپس به غذا اضافه نمایید و صبر کنید غذای شما خوب جا بیفتد.پخته شدن کامل سیب زمینی ها نشان دهنده ی اینست که آب گوشت لپه آماده است."
    ],
    category: 1
  },
  {
    id: 21,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11162910-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D8%AE%D9%88%D8%B4%D9%85%D8%B2%D9%87",
    image_url: "/assets/img/21.jpg",
    title: "آبگوشت خوشمزه",
    publisher: "Mobina Torbi",
    ingredients: [
      "۲ عدد سیب زمینی",
      "۱ عدد پیاز",
      "۴۰۰ گرم گوشت گوسفندی",
      "۳ عدد گوجه",
      "۲ عدد هویج",
      "قلم دو تکه (دلخواه)",
      "۲۰۰ گرم دنبه",
      "ادویه جات (فلفل سیاه و قرمز.زردچوبه.ادویه کاری.نمک)",
      "آب"
    ],
    how_to_make: [
      "پیاز را ریز خرد میکنیم و تفت میدهیم تا سبک شود گوشت و دنبه را اضافه میکنیم و تفت میدهیم ادویه را اضافه میکنیم و دوباره تفت میدهیم و آب را اضافه میکنیم یک ساعت زمان میدیم تا گوشت پخته شود",
      "یک گوجه پوست گرفته و اضافه میکنیم وقتی پخته شد با یک تکه دنبه از قابلمه خارج میکنیم و میکوبیم و دوباره اضافش میکنیم به ابگوشتمون",
      "وقتی گوشت ها خوب پخته شدن سیب زمینی و هویج و گوجه های پوست گرفته رو با مقدار کافی از نمک به آبگوشت اضافه میکنیم وقتی کل مواد پخته شدن میتویم سرو کنیم",
      "این آبگوشت حبوبات نداره و باعث نفخ شکم نمیشه ولی مزش عالیه برای سرو هم آبگوشت تلیت میشه و محتویات رو ترجیحا با نون سنگک نوش جان کنید."
    ],
    category: 1
  },
  {
    id: 22,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11154952-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA",
    image_url: "/assets/img/22.jpg",
    title: "آبگوشت",
    publisher: "man va hamsar",
    ingredients: [
      "۲۵۰ گرم گوشت گوسفندی",
      "۵۰ گرم چربی (یا قلوه گاه)",
      "لوبیا و نخود نصف لیوان چای خوری",
      "۱ عدد پیاز بزرگ",
      "۳عدد گوجه فرنگی",
      "۲ عدد لیمو عمانی",
      "۲ عدد سیب زمینی متوسط",
      "دارچین،نمک ، زردچوبه و فلفل"
    ],
    how_to_make: [
      "گوشت، دنبه، گوجه فرنگی، که از وسط به دو نیم کردم و پیاز رو هم که از وسط به دو نیم کردم رو داخل قابلمه میریزیم و حدود ۵ الی ۶ برابر حجم مواد آب اضافه میکینم. من پیاز رو خورد نکردم چون میخواستم بعد پخت گوشت پیاز رو از آب دربیارم",
      "حالا در قابلمه رو میبندیم و شعله رو هم زیاد میکنیم تا آب جوش بیاد. وقتی آبجوش اومد کفهای روی سطح آب رو با یه قاشق برمیداریم.",
      "حالا به موادمون زرچوبه و فلفل اضافه میکنیم و شعله رو هم کاملا ملایم کرده در قابلمه رو هم میذاریم و اجازه میدیم تا آروم آروم بپزن.",
      "بعد از حدود ۲ الی ۳ ساعت موادمون خوب پختن در این مرحله سیب زمینی ها رو هم از وسط نصف کرده به همراه کنسرو نخود و لوبیا و به آبگوشت اضافه میکنیم و در صورت تمایل لیمو عمانی ها رو هم داخل آبگوشت میریزیم. بعد از اضافه کردن سیب زمینی و لیمو عمانی، رب گوجه فرنگی، نمک و در صورت تمایل دارچین رو هم اضافه میکنیم و اجازه میدیم تا باز موادمون برای ۱ الی ۲ ساعت دیگه آروم آروم بپزن.",
      "آبگوشت ما بعد از زمان کلی تقریبا ۴ ساعت دیگه حسابی جا افتاده و به روغن انداخته و حاضره."
    ],
    category: 1
  },
  {
    id: 23,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11132833-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA",
    image_url: "/assets/img/23.jpg",
    title: "آبگوشت",
    publisher: "fatemeh",
    ingredients: [
      "1 بسته گوشت گوسفندی با دنبه",
      "2 عدد پیاز",
      "2 قاشق غذاخوری رب",
      "ادویه",
      "1 پیمانه نخود",
      "بامیه"
    ],
    how_to_make: [
      "پیاز داغ کرده بعد از سبک شدن زردچوبه میزنیم بعد گوشت ها رو اضافه کرده تفت میدیم نخود ها رو که از شب قبل خیس کرده آبش رو گرفته اضافه میکنیم میزاریم خوب بپزه",
      "بعد از پخت رب زده نیم ساعت قبل نمک زده و سیب زمینی ها و بامیه رو هم اضافه میکنیم میزاریم خوب بپزه و آبگوشت ما اما دست نوش جان"
    ],
    category: 1
  },
  {
    id: 24,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11015760-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D9%85%D8%A7%D9%85%D8%A7%D9%86-%D9%BE%D8%B2-%F0%9F%98%80%F0%9F%91%8F%F0%9F%8F%BB%F0%9F%91%8F%F0%9F%8F%BB%F0%9F%91%8F%F0%9F%8F%BB",
    image_url: "/assets/img/24.jpg",
    title: "آبگوشت مامان پز",
    publisher: "nazanin",
    ingredients: [
      "1/2 كيلو گوشت ماهيچه",
      "100 گرم دنبه",
      "1 ليوان نخود و لوبيا سفيد",
      "3 عدد سيب زميني متوسط",
      "1 عدد پياز بزرگ",
      "3 ق غ خ رب گوجه",
      "نمك و ادويه",
      "1 عدد ليمو عماني",
      "2 ق غ خ مرزه و ترخون خشك"
    ],
    how_to_make: [
      "به نام خدا",
      "ليمو رو ميشكنيم هسته هاشو و پوستشو جدا ميكنيم حبوباتمون رو از شب قبل ميزاريم خيس بخوره",
      "همه مواد رو ميريزيم توي زودپز ميزاريم بپزه بجز نمك",
      "وقتي پخت يكي از سيب زميني ها و پياز و دنبه رو درمياريم با گوشتكوب ميكوبيم بعد دوباره ميريزيم توي آب گوشتمون تا جا بيفته",
      "نوش جان"
    ],
    category: 1
  },
  {
    id: 25,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/11012815-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA",
    image_url: "/assets/img/25.jpg",
    title: "آبگوشت",
    publisher: "Moslm Janfda",
    ingredients: [
      "گوشت گوسفند،نخود",
      "پیاز ،سیب زمینی",
      "زردچوبه،هل،آب،رب ،نمک"
    ],
    how_to_make: [
      "اول گوشت سرخ میکنم بعد پیاز بهش اضافه میکنم و تفتمیدم وقتی سرخ شد بهش زردچوبه و رب میزنیم و بعد آب جوش بهش اضافه میکنیم و هل،نخود و سیب زمینی پوست کنده اضافه میکنیم و بعد از اینکه گوشت پخت بهش نمک اضافه میکنیم"
    ],
    category: 1
  },
  {
    id: 26,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10988977-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D8%AC%D8%A7%D8%A7%D8%A7%D9%86",
    image_url: "/assets/img/26.jpg",
    title: "آبگوشت جااان",
    publisher: "Sara H",
    ingredients: [
      "۴۰۰ گرم گوشت گوسفندی",
      "۳ عدد سیب زمینی",
      "۱۰۰ گرم نخود",
      "۱ عدد پیاز",
      "۳ عدد گوجه فرنگی",
      "نمک و ادویه",
      "ترخون خشک",
      "۲ قاشق غ رب گوجه فرنگی"
    ],
    how_to_make: [
      "در ابتدا گوشت رو مقداری تفت میدم که رنگش تغییر کنه و گوشت آب خون نداشته باشه.بعد پیاز خرد شده رو اضافه میکنم و تفت میدم تاجایی که پیاز سبک بشه.بعد ادویه رو بجز نمک اضافه میکنم.",
      "و بعد گوجه خرد شده رو اضافه میکنم و تفت میدم و در همین حال نخود رو اضافه میکنم و فرصت کافی میدم که گوشت و نخود پخته بشه",
      "بعد داخل یه قابلمه دیگه رب گوجه رو با کمی روغن سرخ میکنم و به آبگوشت پخته شده به اضافه سیب زمینی اضافه میکنم و باز اینبار به سیب زمینی فرصت میدم پخته بشه.و پنج دقیقه قبل از خاموش کردن شعله ترخون خشک رو اضافه میکنم.",
      "نوش جان"
    ],
    category: 1
  },
  {
    id: 29,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/9632268-%D9%87%D8%A7%D9%84%D8%A7%D9%88-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D9%85%D8%AD%D9%84%DB%8C?via=search&search_term=%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA",
    image_url: "/assets/img/29.jpg",
    title: "هالاو (آبگوشت محلی)",
    publisher: "Ashpazye_parchin",
    ingredients: [
      "۳۵۰ گرم گوشت گوسفندی با دنبه",
      "۱ عدد پیاز متوسط",
      "نمک، زردچوبه به مقدار لازم",
      "۱ لیوان آبغوره - بسته به ذائقه میتونید کم و زیاد بریزید",
      "سبزی خشک یا تر (نعنا، جعفری، پیازچه، برگ‌چغندر)",
      "۲ تا ۳ عدد سیب‌زمینی - دلخواه",
      "بادمجان هم به میزان دلخواه"
    ],
    how_to_make: [
      "گوشت گوسفندی رو با نخود و لوبیا از قبل خیس خورده و پیاز ریز شده میذاریم بپزه. بعد بهش نمک، زردچوبه و کمی برنج نیم دانه با سبزی مخصوص (نعنا، جعفری، پیازچه، برگ چغندر) هم‌ اضافه‌ کرده میذاریم‌ بپزه‌. خیلیا سیب زمینی‌ نمیریزن‌ توی‌ این‌ غذا ولی من بچه‌هام دوست دارن میریزم. سیب زمینیها رو پوست میکنم‌ میندازم بپزه و جا بیفته، بعد دنبه‌ رو با کمی‌ نعناخشک با گوشت کوب له میکنیم و میکشیم روی هالاو و بنا به ذائقه (کم یا زیاد) آبغوره بهش اضافه میکنیم.بادمجان هم سرخ میکنیم براش",
      "خیلیا بادمجان رو درشت برش میزنن دورشو کمی تفت میدن یا همونجوری خام میندازن تو هالاو بپزه ولی سرخ شده و نپخته دوست داریم😊.🌸من این سبزیها رو خشک میکنم و خشک میریزم. ولی با سبزی تر هم میشه درست کرد اونم خوشمزه س."
    ],
    category: 1
  },
  {
    id: 27,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10930868-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D8%A8%D8%A7%D9%85%DB%8C%D9%87",
    image_url: "/assets/img/27.jpg",
    title: "آبگوشت بامیه",
    publisher: "فی فی",
    ingredients: [
      "1 لیوان بامیه",
      "گوشت به مقداد دلخواه",
      "1 عدد سیب زمینی",
      "1 عدد پیاز متوسط",
      "3 عدد گوجه فرنگی رنده شده",
      "2 قاشق رب گوجه فرنگی",
      "2 لیتر آب جوش",
      "ادویه، نمک، فلفل، پودرزنجبیل ، زردچوبه"
    ],
    how_to_make: [
      "اول گوشت روباکمی آب میجوشونیم، بعد آب اٌضافه رو میریزیم دور ، گوشت رو با پیاز وادویه تفت میدیم وقتی که گوشت ها طلایی شد رب گوجه وگوجه فرنگی رنده شده رو اضافه میکنیم",
      "میزاریم رب گوجه وگوجه خیلی خوب تفت بخورن که بوی خامیشون از بین بره، البته باشعله کم",
      "بعد سیب زمینی وبامیه رو اضافه میکنیم وآب رو میزاریم به شعله ملایم میزاریم بپزه تا جابیفته"
    ],
    category: 1
  },
  {
    id: 28,
    source_url:
      "https://cookpad.com/ir/%D8%AF%D8%B3%D8%AA%D9%88%D8%B1%20%D8%BA%D8%B0%D8%A7/10915002-%D8%A2%D8%A8%DA%AF%D9%88%D8%B4%D8%AA-%D9%86%D8%B9%D9%86%D8%A7%DB%8C%DB%8C",
    image_url: "/assets/img/28.jpg",
    title: "آبگوشت نعنایی",
    publisher: "تینا",
    ingredients: [
      "۴۰۰ گرم گوشت گوسفندی",
      "۱/۲ پیمانه نخود",
      "۱/۲ پیمانه لوبیا سفید",
      "۲ عدد سیب زمینی متوسط",
      "۳ ق غ رب گوجه",
      "۱ ق م زردچوبه",
      "نمک به مقدار لازم",
      "پودر لیمو عمانی",
      "۱ عدد پیاز",
      "۲ ق م نعنا خشک شده"
    ],
    how_to_make: [
      "ابتدا نخود و لوبیا را چند ساعت قبل میزاریم خیس بخوره. بعد گوشت و لوبیا و نخود و با هم میزاریم بپزه",
      "یک ساعت آخر سیب زمینی رو اضافه میکنیم بعد از اینکه سیب زمینی ها پختن نمک و زردچوبه و گوجه ها رو میریزیم.",
      "یک عدد پیاز و رنده میکنیم با چربی گوشت(دنبه)میکوبیم و داخل آبگوشت میریزیم.",
      "رب گوجه رو سرخ میکنیم و در آخر نعنا ی خشک و میریزیم و یک دقیقه بعد خاموش میکنیم و داخل آبگوشت با پودر لیمو عمانی میریزیم نیم ساعت بعد غذا حاضره.من یک عدد پیاز سالم هم توی آبگوشت میندازم."
    ],
    category: 1
  }
];
